import { render, staticRenderFns } from "./create-floor.vue?vue&type=template&id=3bb6b2ce&"
import script from "./create-floor.vue?vue&type=script&lang=ts&"
export * from "./create-floor.vue?vue&type=script&lang=ts&"
import style0 from "./create-floor.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports